export default {
  // these scenarios are from the current tool in production, accessible via cidss.truii.com
  toolScenarios: [],
  selected: null,
  batches: [],
  batchScenarios: {},
};
